import "./App.css";
import { ToastContainer } from "react-toastify";
import Routing from "./routes";
import "./assets/styles/main.scss";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "../src/assets/theme/ThemeContext";

function App() {
  return (
    <ThemeProvider>
      <Routing />
      <ToastContainer
        icon={true}
        theme="colored"
        position="bottom-right"
        autoClose={1000}
        hideProgressBar={true}
        closeButton={false}
        newestOnTop
      />
    </ThemeProvider>
  );
}

export default App;
